// extracted by mini-css-extract-plugin
export var chevronIcon = "_do-2";
export var teamName = "_do-1";
export var teamSwitcherButton = "_do-0";